export default __webpack_public_path__ + "static/media/flood_final2.f9cfaacf.jpg";